<template>
  <div class="alarmList">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container remain">
          <span>报警管理</span>
          <div>
            <img src="../../../assets/images/icon_prompt.png" alt="" />
            <p>
              电话提醒剩余次数：<span>{{ remain.voviceNotifyResidueNum }}</span>&nbsp;次
            </p>
            /
            <p>
              <!-- 短信提醒剩余次数：<span>{{ remain.smsNotifyResidueNum }}</span>&nbsp;次 -->
              短信提醒剩余次数：<span>{{ 0 }}</span>&nbsp;次
            </p>
          </div>
        </div>
        <div class="select-container">
          <div class="select-container-box">
            <el-button size="small" type="info" plain @click="add" class="add" v-if="edit">增加</el-button>
            <!--华南农大权限判断 //测试环境：2082303,正式环境：3868765-->
            <el-button size="small" type="info" plain @click="openPriorityDialog()" class="query" v-if="[2082303, 3868765].includes($store.state.curCompany.id)"
              style="width: 140px">预警优先级设置</el-button>
            <el-button size="small" type="info" plain @click="openTimeDialog()" class="query" v-if="[2082303, 3868765].includes($store.state.curCompany.id)"
              style="width: 120px">风险时间设置</el-button>
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table :data="alarmList" style="width: 100%">
          <i slot="empty">
            <span>暂无数据</span>
          </i>
          <el-table-column prop="fishBaseName" label="基地" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="fishPondName" show-overflow-tooltip align="center" label="塘口">
          </el-table-column>
          <el-table-column prop="equipmentName" show-overflow-tooltip align="center" label="设备名称">
          </el-table-column>
          <el-table-column prop="alarmPhoneList" show-overflow-tooltip align="center" label="警报电话" :formatter="formattPhone">
          </el-table-column>
          <el-table-column prop="isEnable" label="状态" align="center">
            <template slot-scope="scope">
              <el-switch @change="changeStatus($event, scope.row)" v-model="scope.row.isEnable" active-color="#13ce66" inactive-color="rgb(218, 219, 223)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <span class="content-edit" @click="handleEdit(scope.$index, scope.row)">{{ edit ? "编辑" : "查看" }}</span>
              <span v-if="edit" class="content-del" @click="handleDelete(scope.$index, scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 添加弹窗 -->
      <div v-if="dialogFormVisible">
        <el-dialog :title="titleName" :before-close="handleClose" :visible.sync="dialogFormVisible" width="766px">
          <el-form :model="singleAlarm" :rules="rules" ref="ruleForms" class="ruleForms">
            <el-form-item label="绑定基地" prop="fishBaseId" :label-width="formLabelWidth">
              <el-select v-model="singleAlarm.fishBaseId" placeholder="请选择基地" @change="changeBase" :disabled="!edit">
                <el-option v-for="(item, index) in baseList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="绑定塘口" prop="fishPondId" :label-width="formLabelWidth">
              <el-select v-model="singleAlarm.fishPondId" placeholder="请选择塘口" @change="changePond" :disabled="!edit">
                <el-option v-for="(item, index) in pondList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报警设备" prop="equipmentId" :label-width="formLabelWidth">
              <el-select v-model="singleAlarm.equipmentId" placeholder="请选择设备" :disabled="!edit">
                <el-option v-for="(item, index) in euqipmentList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报警方式" prop="checkList" :label-width="formLabelWidth">
              <el-checkbox-group v-model="checkList" @change="changeCheck">
                <el-checkbox label="1">微信</el-checkbox>
                <el-checkbox label="2">语音</el-checkbox>
                <el-checkbox label="3" disabled>短信</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="报警联系人" prop="checkedItem">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            </el-form-item>
            <div class="check-alarm-column">
              <el-checkbox-group v-model="checkedItem" @change="handleCheckedCitiesChange">
                <div class="alarm-column" style="display: flex; flex-direction: column">
                  <el-checkbox v-for="item in alramPeople" :label="item" :key="item.key">
                    {{ item.value + " " + item.attachInfo }}
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
            <el-form-item>
              <el-button @click="handlecancel">取消</el-button>
              <el-button type="primary" @click="save('ruleForms')" :loading="loadingtype">保 存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <!-- 预警优先级设置弹窗 -->
      <div v-if="priorityDialogVisible">
        <el-dialog :title="`预警优先级设置`" :before-close="handleClose" :visible.sync="priorityDialogVisible" width="766px">
          <el-form :model="priorityForm" :rules="priorityRules" ref="priorityForms" class="ruleForms">
            <el-form-item label="离线报警" prop="offlinePriority" :label-width="priorityFormLabelWidth">
              <el-select v-model="priorityForm.offlinePriority" placeholder="请选择优先级">
                <el-option v-for="(item, index) in priorityTypeList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="阈值报警" prop="thresholdValuePriority" :label-width="priorityFormLabelWidth">
              <el-select v-model="priorityForm.thresholdValuePriority" placeholder="请选择优先级">
                <el-option v-for="(item, index) in priorityTypeList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备异常报警" prop="abnormalPriority" :label-width="priorityFormLabelWidth">
              <el-select v-model="priorityForm.abnormalPriority" placeholder="请选择优先级">
                <el-option v-for="(item, index) in priorityTypeList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="handlePriorityDialogCancel">取消</el-button>
              <el-button type="primary" @click="savePriorityDialog('priorityForms')" :loading="loadingtype">保 存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
      <!-- 风险时间设置弹窗 -->
      <div v-if="timeDialogVisible">
        <el-dialog :title="`预警优先级设置`" :before-close="handleClose" :visible.sync="timeDialogVisible" width="766px">
          <el-form :model="timeForm" :rules="timeRules" ref="timeForms" class="ruleForms">
            <el-form-item label="风险时间设置" prop="timeArr" :label-width="priorityFormLabelWidth">
              <div class="alarm-time-dialog-item-box" style="display: flex;justify-content: space-between;">
                <el-time-picker v-model="timeForm.timeArr[0]" placeholder="开始时间(为空则为全天)" class="time-item" style="margin-right: 10px;">
                </el-time-picker>
                -
                <el-time-picker v-model="timeForm.timeArr[1]" placeholder="结束时间(为空则为全天)" class="time-item" style="margin-left: 10px;">
                </el-time-picker>
              </div>
              <!--
              <el-time-picker is-range v-model="timeForm.timeArr" range-separator="至" start-placeholder="开始时间(为空则为全天)" end-placeholder="结束时间(为空则为全天)" placeholder="选择时间范围">
              </el-time-picker>
            -->
            </el-form-item>
            <el-form-item>
              <el-button @click="handleTimeDialogCancel">取消</el-button>
              <el-button type="primary" @click="saveTimeDialog('timeForms')" :loading="loadingtype">保 存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import PageChange from "../../common/PageChange";
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import { Message } from "element-ui";
import alarm from "../../../store/modules/alarm";
import mixins from "@/common/MixIn.js";
import checkPermission from "../../../service/checkPermission.js";
export default {
  name: "AlarmList",
  mixins: [mixins],
  data () {
    return {
      id: "",
      num11: 11,
      alarmList: [],
      dialogFormVisible: false,
      formLabelWidth: "98px",
      titleName: "增加设备",
      baseList: [],
      pondList: [],
      euqipmentList: [],
      loadingtype: false,
      // 编辑数据
      singleAlarm: {
        fishBaseId: 0,
        fishPondId: 0,
        equipmentId: 0,
        alarmTypes: "",
        userIdList: [],
      },
      // 正则匹配
      rules: {
        // checkList: [
        //   { required: true, message: "报警方式必填", trigger: "blur" }
        // ],
        // checkedItem: [
        //   { required: true, message: "报警联系人必填", trigger: "blur" }
        // ],
        // fishBaseId: [
        //   { required: true, message: "请选择所在基地", trigger: "change" }
        // ],
        // fishPondId: [
        //   { required: true, message: "请选择所在塘口", trigger: "change" }
        // ],
        // equipmentId: [
        //   { required: true, message: "请选择设备", trigger: "change" }
        // ],
        // phone: [
        //   {
        //     pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,
        //     message: "联系电话格式不对,请重新输入"
        //   }
        // ]
      },
      remain: {}, //剩余次数
      alramPeople: [],
      checkList: [],
      checkAll: false,
      isIndeterminate: true,
      checkedItem: [],
      phoneName: "",
      // 优先级设置
      priorityFormLabelWidth: "120px",
      priorityDialogVisible: false,
      priorityForm: {},
      priorityRules: {},
      priorityTypeList: [
        { key: 1, value: "高" },
        { key: 2, value: "中" },
        { key: 3, value: "低" }
      ],
      // 风险时间设置
      timeDialogVisible: false,
      timeForm: { timeArr: [] },
      timeRules: {},

    };
  },
  watch: {
    whetherQlw() {
      this.initPagePermission();
    },
  },

  created () {
  },
  async mounted () {
    this.getNotifyNum(); // 获取剩余提醒次数
    this.alarmList = await this.getAlarmLists();
    console.log(112333, this.alarmList);
  },
  methods: {
    ...mapActions(alarm, [
      "getAlarmLists",
      "getBasePond",
      "getSingleAlarm",
      "getEquipmentList",
      "editAlarm",
      "addAlarm",
      "deleteAlarm",
      "getNotifyResidueNum",
      "updateStatus",
      "getEnterSetEquipmentAlarmPriority",
      "saveEnterSetEquipmentAlarmPriority",
      "getEnterSetEquipmentAlarmTime",
      "saveEnterSetEquipmentAlarmTime"
    ]),
    //报警方式
    changeCheck (e) {
      this.singleAlarm.alarmTypes = this.checkList.toString();
    },
    //获取报警联系人
    async getAlarmList () {
      let data = await this.$api.getAlarmList();
      this.alramPeople = data.data;
    },
    handleCheckAllChange (val) {
      console.log("全选", val);

      this.checkedItem = val ? this.alramPeople : [];
      let a = this.checkedItem.map((item) => {
        return item.key;
      });
      this.singleAlarm.userIdList = a;
      console.log(1222, a);
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange (value) {
      console.log("自由选", value.length);
      let a = value.map((item) => {
        return item.key;
      });
      this.singleAlarm.userIdList = a;
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.alramPeople.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.alramPeople.length;
    },

    // 编辑
    async handleEdit (index, row) {
      this.getAlarmList();
      console.log(index, row);
      this.titleName = "编辑报警设备";
      this.dialogFormVisible = true;
      let item = await this.getSingleAlarm(row.id);
      this.singleAlarm.id = row.id;
      this.checkList = item.alarmTypes.split(",");
      this.singleAlarm.alarmTypes = item.alarmTypes;
      if (item.userIdList != null) {
        var resultArr = [];
        item.userIdList.forEach((item) => {
          console.log(this.alramPeople.filter((_item) => _item.key === item));
          resultArr.push(
            this.alramPeople.filter((_item) => _item.key === item)[0]
          );
        });
        console.log("结果", resultArr);
        this.checkedItem = resultArr;
      }

      console.log(3444, this.checkedItem);

      this.singleAlarm.fishBaseId = item.fishBaseId || 0;
      this.singleAlarm.fishPondId = item.fishPondId || 0;
      this.singleAlarm.equipmentId = item.equipmentId || 0;
      this.getBaseList();
      this.changeBase(this.singleAlarm.fishBaseId);
    },

    async getNotifyNum () {
      this.remain = await this.getNotifyResidueNum();
    },
    //状态
    changeStatus (callback, row) {
      let text = "";
      if (callback == true) {
        text = "启用";
      } else {
        text = "禁用";
      }
      this.$confirm(`是否变更状态为${text}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          console.log(444, row.isEnable);
          if (row.isEnable == true) {
            console.log(3);
            this.updateStatus({
              id: row.id,
              isEnable: row.isEnable,
            })
              .then(async () => {
                this.$Alert.info({
                  content: "报警状态已启用！",
                  duration: 1000,
                  status: "success",
                });
                this.alarmList = await this.getAlarmLists();
              })
              .catch((err) => {
                this.$Alert.info({
                  content: err.response.data,
                  duration: 3000,
                  status: "error",
                });
              });
          } else {
            this.updateStatus({
              id: row.id,
              isEnable: row.isEnable,
            })
              .then(async () => {
                this.$Alert.info({
                  content: "报警状态已禁用！",
                  duration: 1000,
                  status: "success",
                });
                this.alarmList = await this.getAlarmLists();
              })
              .catch((err) => {
                this.$Alert.info({
                  content: err.response.data,
                  duration: 3000,
                  status: "error",
                });
              });
          }
        })
        .catch(async () => {
          this.alarmList = await this.getAlarmLists();
        });
      console.log(444, callback, row);
    },
    // 电话格式
    formattPhone (row) {
      if (row.alarmPhoneList != null) {
        if (row.alarmPhoneList.length > 0) {
          return row.alarmPhoneList.toString();
        }
      } else {
        return "--";
      }
    },
    // 基地列表
    async getBaseList () {
      this.baseList = await this.getBasePond(0);
      this.baseList = [
        {
          key: 0,
          value: "全部",
        },
      ].concat(this.baseList);
    },
    async changeBase (e) {
      if (e == 0) {
        this.pondList = [];
        this.singleAlarm.fishPondId = 0;
      } else {
        this.pondList = await this.getBasePond(e);
      }
      this.pondList = [
        {
          key: 0,
          value: "全部",
        },
      ].concat(this.pondList);
      let obj = this.pondList.find((item) => {
        return this.singleAlarm.fishPondId == item.key;
      });
      if (!obj) {
        this.singleAlarm.fishPondId = 0;
      }
      this.changePond(this.singleAlarm.fishPondId);
    },
    // 切换塘口
    async changePond (e) {
      this.euqipmentList = await this.getEquipmentList({
        BaseId: this.singleAlarm.fishBaseId || null,
        PondId: this.singleAlarm.fishPondId || null,
      });
      this.euqipmentList = [
        {
          key: 0,
          value: "全部",
        },
      ].concat(this.euqipmentList);
      let obj = this.euqipmentList.find((item) => {
        return this.singleAlarm.equipmentId == item.key;
      });
      if (!obj) {
        this.singleAlarm.equipmentId = 0;
      }
    },
    //  点击空白处不关闭弹窗
    handleClose (done) {
      if (window.event && window.event.target.tagName !== "I") {
        return;
      } else {
        done();
      }
    },
    handlecancel () {
      this.dialogFormVisible = false;
    },
    add () {
      this.titleName = "添加报警设备";
      this.dialogFormVisible = true;
      this.getAlarmList();
      this.singleAlarm = {
        fishBaseId: 0,
        fishPondId: 0,
        equipmentId: 0,
        alarmTypes: "",
        userIdList: [],
      };

      this.getBaseList();
      this.changeBase(this.singleAlarm.fishBaseId);
    },

    // 设备的更新与添加
    save (formName) {
      this.$refs[formName].validate((valid) => {
        let arr = [];
        let obj = {};
        obj = JSON.parse(JSON.stringify(this.singleAlarm));
        obj.fishBaseId = obj.fishBaseId || null;
        obj.fishPondId = obj.fishPondId || null;
        obj.equipmentId = obj.equipmentId || null;
        if (valid) {
          this.loadingtype = true;
          if (this.titleName === "编辑报警设备") {
            this.editAlarm(obj)
              .then(() => {
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
                this.loadingtype = false;
                this.dialogFormVisible = false;
                // this.equipmentValue = {};
                setTimeout(async () => {
                  this.alarmList = await this.getAlarmLists();
                  console.log(1, this.allarmList);
                }, 100);
              })
              .catch((err) => {
                Message.error(err.response.data);
              });
          } else if (this.titleName === "添加报警设备") {
            console.log(111, obj);

            this.addAlarm(obj)
              .then(() => {
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
                this.dialogFormVisible = false;
                setTimeout(async () => {
                  this.alarmList = await this.getAlarmLists();
                }, 100);
              })
              .catch((err) => {
                Message.error(err.response.data);
              });
          }
        }
      });
    },
    // 删除
    async handleDelete (index, row) {
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.deleteAlarm(row.id);
          this.alarmList = await this.getAlarmList();
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error",
          });
        });
    },

    /*** 预警优先级设置 */
    async openPriorityDialog () {
      const resData = await this.getEnterSetEquipmentAlarmPriority();
      this.priorityForm = resData;
      this.priorityDialogVisible = true;
    },
    handlePriorityDialogCancel () {
      this.priorityDialogVisible = false;
    },
    savePriorityDialog (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadingtype = true;
          let obj = this.priorityForm;
          this.saveEnterSetEquipmentAlarmPriority(obj)
            .then(() => {
              this.$message({
                type: "success",
                message: "保存成功",
              });
              this.loadingtype = false;
              this.priorityDialogVisible = false;
            })
            .catch((err) => {
              Message.error(err.response.data);
            });
        }
      });
    },

    /** 风险时间设置 */
    async openTimeDialog () {
      const resData = await this.getEnterSetEquipmentAlarmTime();
      const { alarmStartTime, alarmEndTime } = resData;
      let timeArr = [null, null]
      if (alarmStartTime && alarmEndTime) {
        const startArr = alarmStartTime.split(":")
        const endArr = alarmEndTime.split(":")
        const startTime = new Date(0, 0, 0, startArr[0], startArr[1], startArr[2])
        const endTime = new Date(0, 0, 0, endArr[0], endArr[1], endArr[2])
        timeArr = [startTime, endTime]
      }
      this.timeForm = {
        timeArr
      }
      this.timeDialogVisible = true;
    },
    handleTimeDialogCancel () {
      this.timeDialogVisible = false;
    },
    saveTimeDialog (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadingtype = true;
          let obj = {
            alarmStartTime: null,
            alarmEndTime: null
          };
          if (this.timeForm && this.timeForm.timeArr && this.timeForm.timeArr.length === 2) {
            const timeArr = this.timeForm.timeArr
            if (timeArr[0]) {
              obj.alarmStartTime = `${timeArr[0].getHours()}:${timeArr[0].getMinutes()}:${timeArr[0].getSeconds()}`
            }
            if (timeArr[1]) {
              obj.alarmEndTime = `${timeArr[1].getHours()}:${timeArr[1].getMinutes()}:${timeArr[1].getSeconds()}`
            }
          }
          this.saveEnterSetEquipmentAlarmTime(obj)
            .then(() => {
              this.$message({
                type: "success",
                message: "保存成功",
              });
              this.loadingtype = false;
              this.timeDialogVisible = false;
            })
            .catch((err) => {
              Message.error(err.response.data);
              this.loadingtype = false;
            });
        }
      });
    },
  },
};
</script>
<style lang="stylus">
.alarmList {
  .el-form-item:nth-child(4) {
    margin-bottom: -10px;
  }
}

.check-alarm-column {
  width: 300px;
  padding: 16px;
  border: 1px solid #e1e1e1;
  max-height: 300px;
  min-height: 100px;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  margin-left: 160px;
  margin-bottom: 30px;
  margin-top: 18px;

  .el-checkbox-group {
    text-align: left !important;
  }

  .el-checkbox+.el-checkbox {
    margin-left: 0 !important;
    margin-top: 10px;
  }
}

.alarmList {
  .el-form-item__content {
    display: flex;
    align-items: center;

    img {
      margin-left: 5px;
      cursor: pointer;
    }
  }
}

.alarmList {
  .el-select .el-tag {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-color: transparent;
    margin: 2px 0 2px 14px;
    background-color: #f0f2f5;
  }

  .content-calibrate {
    opacity: 0;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    // margin-right: -20px;
    cursor: not-allowed;
    color: gray;
  }

  .calibrate {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    margin-right: 20px;
    cursor: pointer;
    color: #45B6F6;
  }

  .remain {
    display: flex;
    align-items: center;
    justify-content: space-between;

    >span {
      font-size: 18px;
      font-weight: bold;
      font-family: MicrosoftYaHei-Bold;
      color: #333;
    }

    img {
      margin-right: 8px;
    }

    >div {
      display: flex;
      align-items: center;
      margin-right: 40px;
      color: #666;

      p {
        display: flex;
        align-items: center;
        margin-right: 10px;
        font-size: 15px;
        color: #666;

        >span {
          font-size: 20px;
          color: #3389ff;
        }

        &:nth-child(3) {
          margin-left: 10px;
        }
      }
    }
  }

  .select-container {
    height: 46px;
  }

  .el-dialog {
    // height:560px;
    position: absolute;
    left: 50%;
    top: -50px;
    border-radius: 6px;
    margin-left: -340px;

    .el-dialog__header {
      border-radius: 6px 6px 0px 0px;
      padding: 16px 20px 16px;
      background: linear-gradient(270deg, rgba(51, 137, 255, 1), rgba(31, 156, 244, 1), rgba(49, 170, 255, 1));

      .el-dialog__title {
        color: #fff;
      }
    }

    .el-input {
      width: 500px;
    }

    .el-input__inner {
      width: 500px;
    }

    .el-select.fishType .el-input, .el-select.fishName .el-input {
      width: 245px !important;
    }

    .el-select.fishType .el-input__inner, .el-select.fishName .el-input__inner {
      width: 245px !important;
    }

    .el-select.fishName {
      margin-left: 13px;
    }

    .el-form-item__content {
      z-index: 999999;
      line-height: 40px;
      position: relative;
      font-size: 14px;
    }

    .el-form .el-form-item .el-form-item__label {
      margin-left: 65px;
      color: #333;
      font-size: 16px;
      text-align: right;
    }

    .ruleForm {
      margin-left: 0px;
    }

    .el-dialog__close {
      color: #fff;
    }

    .dialog-footer {
      padding: 25px 0 20px;
    }

    .el-dialog__footer {
      position: relative;
      bottom: 12px;
      padding: 0px 0px 0px 0px;
      margin-right: 370px;
    }

    .el-button--primary {
      margin-left: 20px;
      background: #3389ff;
    }

    .el-button {
      width: 100px;
      height: 40px;
    }

    .el-button--default {
      margin-left: 160px;
    }

    .el-form-item .el-form-item__label:before {
      position: absolute;
      top: 2px;
      left: -12px;
      color: #fe3223;
    }

    .el-form-item__error {
      padding-top: 2px;
      position: absolute;
      top: 100%;
      left: 74px;
    }

    .el-icon-date {
      position: relative;
    }

    .el-icon-date:before {
      content: '\E608';
      position: absolute;
      left: 13px;
      top: 3px;
    }

    .el-dialog__body {
      // max-height:380px;
      overflow: auto;
    }
  }
}

.alarm-time-dialog-item-box {
  .time-item {
    width: 220px !important;

    .el-input__inner {
      width: 220px !important;
    }
  }
}
</style>
